export enum BackgroundCheckStatusTypes {
  INVALID = 'INVALID',
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED'
}
